import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const DELETE_FILES_PROVIDER_RESET = 'DELETE_FILES_PROVIDER_RESET';
export const DELETE_FILES_PROVIDER_LOADING = 'DELETE_FILES_PROVIDER_LOADING';
export const DELETE_FILES_PROVIDER_SUCCESS = 'DELETE_FILES_PROVIDER_SUCCESS';
export const DELETE_FILES_PROVIDER_REJECT = 'DELETE_FILES_PROVIDER_REJECT';

//* ACTIONS ------------------------------------------------
export const deleteFilesProviderReset = () => ({ type: DELETE_FILES_PROVIDER_RESET });
export const deleteFilesProviderLoading = () => ({ type: DELETE_FILES_PROVIDER_LOADING });
export const deleteFilesProviderSuccess = (payload) => ({ type: DELETE_FILES_PROVIDER_SUCCESS, payload });
export const deleteFilesProviderReject = (payload) => ({ type: DELETE_FILES_PROVIDER_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const deleteFilesProviderRequest = async (data = {}, getState) => {
    const options = await withToken({
        method: Methods.DELETE,
        data,
    }, getState);
    return request(`/Providers/web/DeleteProviderUploadFile/${data}`, options);
};